module.exports = __webpack_public_path__ + "media/images/companies/yomiuri_shinbun-9e1874c6e5ce85b9bd38204a67123bb7.jpg";